$(document).ready(function () {
  slickCarousel();
  thankYouPage();
});

function slickCarousel() {
  $(".top-bar-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    vertical: true,
    verticalSwiping: true,
    dots: false,
    arrows: false,
    draggable: false,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $(".bt-text-and-image-slider-wrapper").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  });

  $(".bt-image-slider-wrapper").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  });
}

function thankYouPage() {
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelector("#contact-form")
      .addEventListener("submit", function () {
        window.location.href = "/pages/thank-you"; // Replace with your thank you page URL
      });
  });
}
